var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContainerDimensions } from '@parca/dynamicsize';
import DiffLegend from '../components/DiffLegend';
import IcicleGraph from './IcicleGraph';
import { selectQueryParam } from '@parca/functions';
import { useEffect, useMemo } from 'react';
var numberFormatter = new Intl.NumberFormat('en-US');
var ProfileIcicleGraph = function (_a) {
    var graph = _a.graph, curPath = _a.curPath, setNewCurPath = _a.setNewCurPath, sampleUnit = _a.sampleUnit, onContainerResize = _a.onContainerResize, navigateTo = _a.navigateTo, loading = _a.loading;
    var compareMode = selectQueryParam('compare_a') === 'true' && selectQueryParam('compare_b') === 'true';
    var _b = useContainerDimensions(), ref = _b.ref, dimensions = _b.dimensions;
    useEffect(function () {
        if (dimensions === undefined)
            return;
        if (onContainerResize === undefined)
            return;
        onContainerResize(dimensions.width, dimensions.height);
    }, [dimensions, onContainerResize]);
    var _c = useMemo(function () {
        if (graph === undefined || graph.untrimmedTotal === '0') {
            return [false, BigInt(0), '0'];
        }
        var untrimmedTotal = BigInt(graph.untrimmedTotal);
        var total = BigInt(graph.total);
        var trimDifference = untrimmedTotal - total;
        var trimmedPercentage = (total * BigInt(100)) / untrimmedTotal;
        return [
            trimDifference > BigInt(0),
            trimDifference,
            trimmedPercentage.toString(),
            numberFormatter.format(total),
            numberFormatter.format(untrimmedTotal),
        ];
    }, [graph]), isTrimmed = _c[0], _ = _c[1], trimmedPercentage = _c[2], formattedTotal = _c[3], formattedUntrimmedTotal = _c[4];
    if (graph === undefined)
        return _jsx("div", { children: "no data..." });
    var total = graph.total;
    if (parseFloat(total) === 0 && !loading)
        return _jsx(_Fragment, { children: "Profile has no samples" });
    return (_jsxs("div", __assign({ className: "relative" }, { children: [compareMode && _jsx(DiffLegend, {}), isTrimmed ? (_jsxs("p", __assign({ className: "my-2 text-sm" }, { children: ["Showing ", formattedTotal, "(", trimmedPercentage, "%) out of ", formattedUntrimmedTotal, " samples"] }))) : null, _jsx("div", __assign({ ref: ref }, { children: _jsx(IcicleGraph, { width: dimensions === null || dimensions === void 0 ? void 0 : dimensions.width, graph: graph, curPath: curPath, setCurPath: setNewCurPath, sampleUnit: sampleUnit, navigateTo: navigateTo, isTrimmed: isTrimmed }) }))] })));
};
export default ProfileIcicleGraph;
